export default "__VITE_ASSET__BQS0x6b0__"